import { create } from 'zustand';
import { Collection, CollectionFilter } from '../types/collection.types';

type CollectionState = {
  // Which collection is open. Its section/page structure lives in the query
  // cache (collectionKeys.structure / public collection queries) and is read
  // through useDisplayedCollectionStructure.
  currentCollection: Collection | null;
  activeFilter: CollectionFilter;
  closedSections: Record<string, boolean>;

  setCurrentCollection: (collection: Collection | null) => void;
  setActiveFilter: (filter: CollectionFilter) => void;
  updateCollection: (id: string, update: Partial<Collection>) => void;
  toggleSection: (sectionId: string) => void;
  resetCurrentCollection: () => void;
};

export const useCollectionStore = create<CollectionState>(set => ({
  currentCollection: null,
  activeFilter: CollectionFilter.All,
  closedSections: {},

  setCurrentCollection: collection => {
    set({ currentCollection: collection });
  },

  setActiveFilter: filter => {
    set({ activeFilter: filter });
  },

  updateCollection: (id, update) => {
    set(state => ({
      currentCollection:
        state.currentCollection?.id === id
          ? { ...state.currentCollection, ...update }
          : state.currentCollection,
    }));
  },

  toggleSection: (sectionId: string) => {
    set(state => ({
      closedSections: {
        ...state.closedSections,
        [sectionId]: !state.closedSections[sectionId],
      },
    }));
  },

  resetCurrentCollection: () => {
    set({
      currentCollection: null,
      closedSections: {},
    });
  },
}));
